// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* New menu: module rail + page panel.
   Rail colours follow the website's dark navy (NAVY in pages/Website/websiteTokens.js). */

:root {
  --nv2-rail-w: 76px;
  --nv2-panel-w: 232px;
  --nv2-navy: #0f1a33;
  --nv2-navy-up: #1a2a4d;
  --nv2-rail-text: #a9b4cc;
  --nv2-pink: #e91e63;
  --nv2-brand: #c2185b;
}

.nv2 {
  display: flex;
  height: 100%;
}

/* ---------- rail ---------- */
.nv2-rail {
  width: var(--nv2-rail-w);
  background: var(--nv2-navy);
  display: flex;
  flex-direction: column;
  padding: 8px 0;
  flex-shrink: 0;
}
.nv2-rail-list {
  flex: 1 1 auto;
  overflow-y: auto;
  scrollbar-width: none;
}
.nv2-rail-list::-webkit-scrollbar { display: none; }

.nv2-rail-btn {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  width: calc(100% - 14px);
  margin: 1px 7px;
  padding: 7px 2px;
  border: 0;
  border-radius: 10px;
  background: transparent;
  color: var(--nv2-rail-text);
  font-size: 10.5px;
  font-weight: 600;
  line-height: 1.15;
  text-align: center;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
}
.nv2-rail-btn:hover { background: rgba(255, 255, 255, 0.07); color: #fff; }
.nv2-rail-btn:focus-visible { outline: 2px solid var(--nv2-pink); outline-offset: 1px; }
.nv2-rail-btn.is-open { background: var(--nv2-navy-up); color: #fff; }
.nv2-rail-btn.is-current { background: rgba(233, 30, 99, 0.2); color: #fff; }
.nv2-rail-btn.is-current::before {
  content: "";
  position: absolute;
  left: -7px;
  top: 10px;
  bottom: 10px;
  width: 3px;
  border-radius: 3px;
  background: var(--nv2-pink);
}
.nv2-rail-label { display: block; max-width: 100%; overflow: hidden; text-overflow: ellipsis; }
.nv2-rail-badge {
  position: absolute;
  top: 3px;
  right: 10px;
  min-width: 17px;
  height: 17px;
  padding: 0 4px;
  border-radius: 9px;
  background: var(--nv2-pink);
  color: #fff;
  font-size: 10px;
  line-height: 17px;
  font-weight: 700;
}
.nv2-rail-foot { border-top: 1px solid rgba(255, 255, 255, 0.08); padding-top: 6px; margin-top: 4px; }

/* Short screens: tighten, then drop the labels (names stay in the tooltip),
   so every module stays reachable without scrolling the rail. */
@media (max-height: 820px) {
  .nv2-rail-btn { padding: 5px 2px; font-size: 10px; }
}
@media (max-height: 680px) {
  .nv2-rail-btn { padding: 8px 2px; }
  .nv2-rail-label { display: none; }
}

/* ---------- panel ---------- */
.nv2-panel {
  width: var(--nv2-panel-w);
  background: #fff;
  border-right: 1px solid #e9ecef;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  box-shadow: 4px 0 18px rgba(15, 23, 42, 0.04);
}
.nv2[data-overlay="true"] .nv2-panel { box-shadow: 8px 0 30px rgba(15, 23, 42, 0.18); }
.nv2-panel-head { display: flex; align-items: center; gap: 8px; padding: 14px 12px 6px 18px; }
.nv2-panel-head h2 { margin: 0; font-size: 15px; font-weight: 700; color: #1f2937; }
.nv2-icon-btn {
  margin-left: auto;
  width: 28px;
  height: 28px;
  display: grid;
  place-items: center;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #fff;
  color: #6b7280;
  cursor: pointer;
}
.nv2-icon-btn:hover { border-color: var(--nv2-brand); color: var(--nv2-brand); }
.nv2-panel-body { flex: 1 1 auto; overflow-y: auto; padding: 2px 10px 12px; }
.nv2-panel-body::-webkit-scrollbar { width: 6px; }
.nv2-panel-body::-webkit-scrollbar-thumb { background: #dfe2e7; border-radius: 6px; }
.nv2-sec {
  padding: 14px 10px 5px;
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: #9ca3af;
}
.nv2-row { position: relative; display: flex; align-items: center; border-radius: 8px; }
.nv2-row:hover { background: #f4f5f7; }
.nv2-link {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 7px 4px 7px 10px;
  border-radius: 8px;
  color: #4b5563;
  font-size: 13.5px;
  font-weight: 500;
  text-decoration: none;
}
.nv2-link:hover { color: #1f2937; }
.nv2-link span.nv2-text { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.nv2-row.is-active { background: rgba(194, 24, 91, 0.08); }
.nv2-row.is-active .nv2-link { color: var(--nv2-brand); font-weight: 600; }
.nv2-row.is-active::before {
  content: "";
  position: absolute;
  left: -10px;
  top: 6px;
  bottom: 6px;
  width: 3px;
  border-radius: 3px;
  background: var(--nv2-brand);
}
.nv2-count {
  margin-left: auto;
  background: var(--nv2-brand);
  color: #fff;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  padding: 1px 7px;
}
.nv2-star {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  display: grid;
  place-items: center;
  border: 0;
  background: transparent;
  color: #c7cbd3;
  cursor: pointer;
  opacity: 0;
  border-radius: 6px;
}
.nv2-row:hover .nv2-star,
.nv2-star:focus-visible,
.nv2-star.is-pinned { opacity: 1; }
.nv2-star.is-pinned { color: #f59e0b; }
@media (hover: none) { .nv2-star { opacity: 1; } }
.nv2-hint { font-size: 12px; color: #9ca3af; padding: 2px 10px; }
.nv2-panel-foot {
  display: flex;
  align-items: center;
  gap: 8px;
  border-top: 1px solid #f0f1f4;
  padding: 8px 12px;
}
.nv2-search-btn {
  flex: 1 1;
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid #e3e5ea;
  background: #f8f9fb;
  border-radius: 9px;
  padding: 6px 9px;
  color: #6b7280;
  font-size: 12.5px;
  cursor: pointer;
}
.nv2-search-btn:hover { border-color: var(--nv2-brand); color: var(--nv2-brand); }
.nv2-kbd {
  margin-left: auto;
  font-size: 10.5px;
  border: 1px solid #dcdfe5;
  border-radius: 5px;
  padding: 0 5px;
  background: #fff;
  color: #4b5563;
}
.nv2-text-btn { border: 0; background: none; color: #6b7280; font-size: 12px; cursor: pointer; padding: 4px; white-space: nowrap; }
.nv2-text-btn:hover { color: var(--nv2-brand); text-decoration: underline; }

/* ---------- navbar search pill ---------- */
.nv2-navbar-search {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 360px;
  max-width: 34vw;
  margin-left: 24px;
  border: 1px solid #e3e5ea;
  background: #f8f9fb;
  border-radius: 10px;
  padding: 7px 10px;
  color: #9ca3af;
  font-size: 13.5px;
  cursor: pointer;
}
.nv2-navbar-search:hover { border-color: var(--nv2-brand); }

/* ---------- Ctrl+K search ---------- */
.nv2-pal-scrim {
  position: fixed;
  inset: 0;
  z-index: 2100;
  background: rgba(15, 23, 42, 0.35);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 12vh;
}
.nv2-pal {
  width: 620px;
  max-width: 94vw;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 30px 80px rgba(15, 23, 42, 0.35);
  overflow: hidden;
}
.nv2-pal input {
  width: 100%;
  border: 0;
  border-bottom: 1px solid #eceef2;
  padding: 16px 18px;
  font-size: 16px;
  outline: none;
}
.nv2-pal-list { max-height: 420px; overflow-y: auto; padding: 6px; margin: 0; list-style: none; }
.nv2-pal-group {
  padding: 10px 12px 4px;
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: #9ca3af;
}
.nv2-pal-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 12px;
  border-radius: 8px;
  cursor: pointer;
  color: #1f2937;
  font-size: 14px;
}
.nv2-pal-item small { margin-left: auto; color: #9ca3af; font-size: 12px; white-space: nowrap; }
.nv2-pal-item.is-sel { background: rgba(194, 24, 91, 0.08); color: var(--nv2-brand); }
.nv2-pal-empty { padding: 18px; color: #9ca3af; }
.nv2-pal-foot { display: flex; gap: 14px; padding: 8px 14px; border-top: 1px solid #eceef2; font-size: 11.5px; color: #9ca3af; }
`, "",{"version":3,"sources":["webpack://./src/components/NavV2/navV2.css"],"names":[],"mappings":"AAAA;0FAC0F;;AAE1F;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,wBAAwB;EACxB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA,+BAA+B;AAC/B;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;AACA,oCAAoC,aAAa,EAAE;;AAEnD;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,yCAAyC;AAC3C;AACA,sBAAsB,qCAAqC,EAAE,WAAW,EAAE;AAC1E,8BAA8B,kCAAkC,EAAE,mBAAmB,EAAE;AACvF,wBAAwB,8BAA8B,EAAE,WAAW,EAAE;AACrE,2BAA2B,kCAAkC,EAAE,WAAW,EAAE;AAC5E;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,2BAA2B;AAC7B;AACA,kBAAkB,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE,uBAAuB,EAAE;AAC9F;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,eAAe;EACf,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,2BAA2B;EAC3B,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA,iBAAiB,+CAA+C,EAAE,gBAAgB,EAAE,eAAe,EAAE;;AAErG;gEACgE;AAChE;EACE,gBAAgB,gBAAgB,EAAE,eAAe,EAAE;AACrD;AACA;EACE,gBAAgB,gBAAgB,EAAE;EAClC,kBAAkB,aAAa,EAAE;AACnC;;AAEA,gCAAgC;AAChC;EACE,yBAAyB;EACzB,gBAAgB;EAChB,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,6CAA6C;AAC/C;AACA,uCAAuC,6CAA6C,EAAE;AACtF,kBAAkB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,2BAA2B,EAAE;AAC7F,qBAAqB,SAAS,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACnF;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA,sBAAsB,8BAA8B,EAAE,uBAAuB,EAAE;AAC/E,kBAAkB,cAAc,EAAE,gBAAgB,EAAE,sBAAsB,EAAE;AAC5E,qCAAqC,UAAU,EAAE;AACjD,2CAA2C,mBAAmB,EAAE,kBAAkB,EAAE;AACpF;EACE,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;AACA,WAAW,kBAAkB,EAAE,aAAa,EAAE,mBAAmB,EAAE,kBAAkB,EAAE;AACvF,iBAAiB,mBAAmB,EAAE;AACtC;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;AACA,kBAAkB,cAAc,EAAE;AAClC,0BAA0B,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AAC1F,qBAAqB,mCAAmC,EAAE;AAC1D,+BAA+B,uBAAuB,EAAE,gBAAgB,EAAE;AAC1E;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,4BAA4B;AAC9B;AACA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,UAAU;EACV,kBAAkB;AACpB;AACA;;sBAEsB,UAAU,EAAE;AAClC,sBAAsB,cAAc,EAAE;AACtC,uBAAuB,YAAY,UAAU,EAAE,EAAE;AACjD,YAAY,eAAe,EAAE,cAAc,EAAE,iBAAiB,EAAE;AAChE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,6BAA6B;EAC7B,iBAAiB;AACnB;AACA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;AACA,wBAAwB,8BAA8B,EAAE,uBAAuB,EAAE;AACjF;EACE,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;AACA,gBAAgB,SAAS,EAAE,gBAAgB,EAAE,cAAc,EAAE,eAAe,EAAE,eAAe,EAAE,YAAY,EAAE,mBAAmB,EAAE;AAClI,sBAAsB,uBAAuB,EAAE,0BAA0B,EAAE;;AAE3E,6CAA6C;AAC7C;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;AACA,2BAA2B,8BAA8B,EAAE;;AAE3D,wCAAwC;AACxC;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,kCAAkC;EAClC,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,8CAA8C;EAC9C,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,SAAS;EACT,gCAAgC;EAChC,kBAAkB;EAClB,eAAe;EACf,aAAa;AACf;AACA,gBAAgB,iBAAiB,EAAE,gBAAgB,EAAE,YAAY,EAAE,SAAS,EAAE,gBAAgB,EAAE;AAChG;EACE,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA,sBAAsB,iBAAiB,EAAE,cAAc,EAAE,eAAe,EAAE,mBAAmB,EAAE;AAC/F,uBAAuB,mCAAmC,EAAE,uBAAuB,EAAE;AACrF,iBAAiB,aAAa,EAAE,cAAc,EAAE;AAChD,gBAAgB,aAAa,EAAE,SAAS,EAAE,iBAAiB,EAAE,6BAA6B,EAAE,iBAAiB,EAAE,cAAc,EAAE","sourcesContent":["/* New menu: module rail + page panel.\n   Rail colours follow the website's dark navy (NAVY in pages/Website/websiteTokens.js). */\n\n:root {\n  --nv2-rail-w: 76px;\n  --nv2-panel-w: 232px;\n  --nv2-navy: #0f1a33;\n  --nv2-navy-up: #1a2a4d;\n  --nv2-rail-text: #a9b4cc;\n  --nv2-pink: #e91e63;\n  --nv2-brand: #c2185b;\n}\n\n.nv2 {\n  display: flex;\n  height: 100%;\n}\n\n/* ---------- rail ---------- */\n.nv2-rail {\n  width: var(--nv2-rail-w);\n  background: var(--nv2-navy);\n  display: flex;\n  flex-direction: column;\n  padding: 8px 0;\n  flex-shrink: 0;\n}\n.nv2-rail-list {\n  flex: 1 1 auto;\n  overflow-y: auto;\n  scrollbar-width: none;\n}\n.nv2-rail-list::-webkit-scrollbar { display: none; }\n\n.nv2-rail-btn {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 2px;\n  width: calc(100% - 14px);\n  margin: 1px 7px;\n  padding: 7px 2px;\n  border: 0;\n  border-radius: 10px;\n  background: transparent;\n  color: var(--nv2-rail-text);\n  font-size: 10.5px;\n  font-weight: 600;\n  line-height: 1.15;\n  text-align: center;\n  cursor: pointer;\n  transition: background 0.15s, color 0.15s;\n}\n.nv2-rail-btn:hover { background: rgba(255, 255, 255, 0.07); color: #fff; }\n.nv2-rail-btn:focus-visible { outline: 2px solid var(--nv2-pink); outline-offset: 1px; }\n.nv2-rail-btn.is-open { background: var(--nv2-navy-up); color: #fff; }\n.nv2-rail-btn.is-current { background: rgba(233, 30, 99, 0.2); color: #fff; }\n.nv2-rail-btn.is-current::before {\n  content: \"\";\n  position: absolute;\n  left: -7px;\n  top: 10px;\n  bottom: 10px;\n  width: 3px;\n  border-radius: 3px;\n  background: var(--nv2-pink);\n}\n.nv2-rail-label { display: block; max-width: 100%; overflow: hidden; text-overflow: ellipsis; }\n.nv2-rail-badge {\n  position: absolute;\n  top: 3px;\n  right: 10px;\n  min-width: 17px;\n  height: 17px;\n  padding: 0 4px;\n  border-radius: 9px;\n  background: var(--nv2-pink);\n  color: #fff;\n  font-size: 10px;\n  line-height: 17px;\n  font-weight: 700;\n}\n.nv2-rail-foot { border-top: 1px solid rgba(255, 255, 255, 0.08); padding-top: 6px; margin-top: 4px; }\n\n/* Short screens: tighten, then drop the labels (names stay in the tooltip),\n   so every module stays reachable without scrolling the rail. */\n@media (max-height: 820px) {\n  .nv2-rail-btn { padding: 5px 2px; font-size: 10px; }\n}\n@media (max-height: 680px) {\n  .nv2-rail-btn { padding: 8px 2px; }\n  .nv2-rail-label { display: none; }\n}\n\n/* ---------- panel ---------- */\n.nv2-panel {\n  width: var(--nv2-panel-w);\n  background: #fff;\n  border-right: 1px solid #e9ecef;\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 0;\n  box-shadow: 4px 0 18px rgba(15, 23, 42, 0.04);\n}\n.nv2[data-overlay=\"true\"] .nv2-panel { box-shadow: 8px 0 30px rgba(15, 23, 42, 0.18); }\n.nv2-panel-head { display: flex; align-items: center; gap: 8px; padding: 14px 12px 6px 18px; }\n.nv2-panel-head h2 { margin: 0; font-size: 15px; font-weight: 700; color: #1f2937; }\n.nv2-icon-btn {\n  margin-left: auto;\n  width: 28px;\n  height: 28px;\n  display: grid;\n  place-items: center;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  background: #fff;\n  color: #6b7280;\n  cursor: pointer;\n}\n.nv2-icon-btn:hover { border-color: var(--nv2-brand); color: var(--nv2-brand); }\n.nv2-panel-body { flex: 1 1 auto; overflow-y: auto; padding: 2px 10px 12px; }\n.nv2-panel-body::-webkit-scrollbar { width: 6px; }\n.nv2-panel-body::-webkit-scrollbar-thumb { background: #dfe2e7; border-radius: 6px; }\n.nv2-sec {\n  padding: 14px 10px 5px;\n  font-size: 10.5px;\n  font-weight: 700;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n  color: #9ca3af;\n}\n.nv2-row { position: relative; display: flex; align-items: center; border-radius: 8px; }\n.nv2-row:hover { background: #f4f5f7; }\n.nv2-link {\n  flex: 1 1 auto;\n  min-width: 0;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 7px 4px 7px 10px;\n  border-radius: 8px;\n  color: #4b5563;\n  font-size: 13.5px;\n  font-weight: 500;\n  text-decoration: none;\n}\n.nv2-link:hover { color: #1f2937; }\n.nv2-link span.nv2-text { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.nv2-row.is-active { background: rgba(194, 24, 91, 0.08); }\n.nv2-row.is-active .nv2-link { color: var(--nv2-brand); font-weight: 600; }\n.nv2-row.is-active::before {\n  content: \"\";\n  position: absolute;\n  left: -10px;\n  top: 6px;\n  bottom: 6px;\n  width: 3px;\n  border-radius: 3px;\n  background: var(--nv2-brand);\n}\n.nv2-count {\n  margin-left: auto;\n  background: var(--nv2-brand);\n  color: #fff;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 700;\n  padding: 1px 7px;\n}\n.nv2-star {\n  flex-shrink: 0;\n  width: 28px;\n  height: 28px;\n  display: grid;\n  place-items: center;\n  border: 0;\n  background: transparent;\n  color: #c7cbd3;\n  cursor: pointer;\n  opacity: 0;\n  border-radius: 6px;\n}\n.nv2-row:hover .nv2-star,\n.nv2-star:focus-visible,\n.nv2-star.is-pinned { opacity: 1; }\n.nv2-star.is-pinned { color: #f59e0b; }\n@media (hover: none) { .nv2-star { opacity: 1; } }\n.nv2-hint { font-size: 12px; color: #9ca3af; padding: 2px 10px; }\n.nv2-panel-foot {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  border-top: 1px solid #f0f1f4;\n  padding: 8px 12px;\n}\n.nv2-search-btn {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  border: 1px solid #e3e5ea;\n  background: #f8f9fb;\n  border-radius: 9px;\n  padding: 6px 9px;\n  color: #6b7280;\n  font-size: 12.5px;\n  cursor: pointer;\n}\n.nv2-search-btn:hover { border-color: var(--nv2-brand); color: var(--nv2-brand); }\n.nv2-kbd {\n  margin-left: auto;\n  font-size: 10.5px;\n  border: 1px solid #dcdfe5;\n  border-radius: 5px;\n  padding: 0 5px;\n  background: #fff;\n  color: #4b5563;\n}\n.nv2-text-btn { border: 0; background: none; color: #6b7280; font-size: 12px; cursor: pointer; padding: 4px; white-space: nowrap; }\n.nv2-text-btn:hover { color: var(--nv2-brand); text-decoration: underline; }\n\n/* ---------- navbar search pill ---------- */\n.nv2-navbar-search {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 360px;\n  max-width: 34vw;\n  margin-left: 24px;\n  border: 1px solid #e3e5ea;\n  background: #f8f9fb;\n  border-radius: 10px;\n  padding: 7px 10px;\n  color: #9ca3af;\n  font-size: 13.5px;\n  cursor: pointer;\n}\n.nv2-navbar-search:hover { border-color: var(--nv2-brand); }\n\n/* ---------- Ctrl+K search ---------- */\n.nv2-pal-scrim {\n  position: fixed;\n  inset: 0;\n  z-index: 2100;\n  background: rgba(15, 23, 42, 0.35);\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding-top: 12vh;\n}\n.nv2-pal {\n  width: 620px;\n  max-width: 94vw;\n  background: #fff;\n  border-radius: 14px;\n  box-shadow: 0 30px 80px rgba(15, 23, 42, 0.35);\n  overflow: hidden;\n}\n.nv2-pal input {\n  width: 100%;\n  border: 0;\n  border-bottom: 1px solid #eceef2;\n  padding: 16px 18px;\n  font-size: 16px;\n  outline: none;\n}\n.nv2-pal-list { max-height: 420px; overflow-y: auto; padding: 6px; margin: 0; list-style: none; }\n.nv2-pal-group {\n  padding: 10px 12px 4px;\n  font-size: 10.5px;\n  font-weight: 700;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n  color: #9ca3af;\n}\n.nv2-pal-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 9px 12px;\n  border-radius: 8px;\n  cursor: pointer;\n  color: #1f2937;\n  font-size: 14px;\n}\n.nv2-pal-item small { margin-left: auto; color: #9ca3af; font-size: 12px; white-space: nowrap; }\n.nv2-pal-item.is-sel { background: rgba(194, 24, 91, 0.08); color: var(--nv2-brand); }\n.nv2-pal-empty { padding: 18px; color: #9ca3af; }\n.nv2-pal-foot { display: flex; gap: 14px; padding: 8px 14px; border-top: 1px solid #eceef2; font-size: 11.5px; color: #9ca3af; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
